<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增广告组
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="false"
      >
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider
            type="vertical"
          />
          <a
            href="javascript:;"
            @click="() => onPages(record)"
          >管理页面</a>
          <a-divider
            type="vertical"
          />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <rank-modal
      ref="formRef"
      :btn-is-loading="btnIsLoading"
      :visible="visible"
      :title="title"
      @onCancel="onCancel"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import RankModal from './modal/index';
export default {
  components: { RankModal },
  data() {
    return {
      btnIsLoading: false,
      columns,
      data: [],
      loading: false,
      visible: false,
      title: '',
      id: '',
    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData();
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post(
        '/slide/index',
        params,
      );
      if (result.data.status === 1) {
        this.loading = false;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            name: item.name,
            remark: item.remark,
            status: item.status,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 新增 编辑
    editAndAdd(record) {
      this.visible=true;
      if (!record.id) {
        this.title = '新增广告组';
        this.id=undefined;
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.id=record.id;
        this.title = '编辑广告组';
        let data={
          name: record.name,
          remark: record.remark,
        };
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确认新增
    handleSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoading=true;
            values.id=this.id?this.id:undefined;
            let result = await this.$http.post(
              '/slide/update',
              values,
            );
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.visible = false;
              this.getTableData();
            }
          }
        },
      );
    },
    // 取消新增
    onCancel() {
      this.visible = false;
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/slide/del', {id: record.id});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ keyword: this.keyword});
      }
    },
    // 页面管理
    onPages(record){
      this.$router.push({path: '/adverPage', query: {id: record.id}});
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
